import { render } from "./MakeOfferPage.vue?vue&type=template&id=164cf85e&scoped=true"
import script from "./MakeOfferPage.vue?vue&type=script&lang=js"
export * from "./MakeOfferPage.vue?vue&type=script&lang=js"

import "./MakeOfferPage.vue?vue&type=style&index=0&id=164cf85e&lang=css"
import "./MakeOfferPage.vue?vue&type=style&index=1&id=164cf85e&lang=css"
import "./MakeOfferPage.vue?vue&type=style&index=2&id=164cf85e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164cf85e"]])

export default __exports__